import React from "react"
import { Link } from "gatsby"
import { ModalRoutingContext } from "gatsby-plugin-modal-routing-3"
import { languageUtils } from "@utils/language"
import Logo from "@images/mutua-logo.png"


const Modal = ({ title, children }) => {

  const titles = {
    cas: "Informe de Gestión y Memoria de Sostenibilidad 2020",
    cat: "Informe de Gestió i Memòria de Sostenibilitat 2020",
    eng: "Management and Sustainability Report 2020",
    eus: "2020ko kudeaketa txostena eta Jasangarritasunaren memoria",
    gal: "Informe de Xestión e Memoria de Sostibilidade 2020",
  }

  return (
  <ModalRoutingContext.Consumer>
    {({ modal, closeTo }) => {
      const lang = languageUtils.getLanguage()
      let path =
        typeof window !== "undefined" ? window.location.pathname : "/" + lang
      let parts = path.split("/")

      while (parts[0] !== lang) {
        parts.shift()
      }

      path = `/${parts[0]}/${parts[1]}/`

      return (
        <div className={modal ? "" : "modal-wrapper"}>
          <div className={modal ? "" : "modal-content"}>
            <div className="topLine">
              <div className="logo">
                <img src={Logo} alt=""></img>
                <span>{titles[lang]}</span>
              </div>
              <div className="title">{title}</div>
            </div>
            <Link to={modal ? closeTo : path}>
              <div className="close-modal"></div>
            </Link>
            <section>{children}</section>
          </div>
          <div className="element changePage"></div>
        </div>
      )
    }}
  </ModalRoutingContext.Consumer>
  )
  }

export default Modal
